import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const CircleIcon = props => (
  <SvgIcon viewBox="0 0 1417.323 1417.323" {...props}>
    <path d="M708.661,1417.323 C317.279,1417.323 0,1100.044 0,708.661 C0,317.279 317.279,0 708.661,0 C1100.044,0 1417.323,317.279 1417.323,708.661 C1417.323,1100.044 1100.044,1417.323 708.661,1417.323 z" />
  </SvgIcon>
);
